<template>
  <div class="record-lecture">
    <!-- <div class="backhome" @click="backhomepage"></div> -->
    <h1>
      <!-- <i class="el-icon-microphone"></i> -->
      <img :src="audio_img" alt="" />
      Record Lecture
    </h1>
    <p>Make sure the recording is longer than <span style="color: red;font-size: 1.6vw;">1</span> minute.</p>
    <p>Time Max : {{ maxrecordtime }}minutes</p>
    <div class="notradio" v-show="radiostatus == 'notradio'">

      <div :disabled="isRecording" @click="startRecording()" class="record-button1">
        <i class="el-icon-microphone"></i>
      </div>
      <div class="record-mode-header">
        <div class="record-mode-title">Online-course Mode</div>
        <div class="record-mode-toggle">
          <label class="switch">
            <input type="checkbox" v-model="isSystemAudio">
            <span class="slider round"></span>
          </label>
          <div class="toggle-labels">
            <div class="toggle-label">
              <span v-if="!isSystemAudio">OFF</span>
              <span v-else>ON</span>
            </div>
            <div class="tip-text">
              <div class="custom-tooltip-diy">
                <i class="el-icon-question"></i>
                <div class="tooltip-content">
                  Captures audio directly from a browser tab<br>
                  ideal for online classes or web meetings
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="startradio" v-show="radiostatus == 'startradio'">
      <div class="waveform">
        <canvas ref="waveformCanvas" width="1800" height="100"></canvas>
      </div>
      <div class="timer">
        {{ formattedTime }}
      </div>
      <div class="controls">
        <div @click="toggleRecording()" class="record-button">
          <i v-if="isRecording" class="el-icon-video-pause"></i>
          <i v-else class="el-icon-microphone record-button-microphone"></i>
        </div>
        <div @click="stopRecording" class="stop-button" :disabled="!audioUrl">
          <i></i>
        </div>
        <div @click="clearRecording" v-if="false" class="clear-button" :disabled="!audioUrl">
          Clear
        </div>
      </div>
    </div>

    <!-- 系统内录音错误提示 -->
    <transition name="fade">
      <div class="tip-container">
        <div v-if="showSystemAudioTip" class="system-audio-tip"
          :class="{ 'error': invalidCaptureType, 'warning': isBrowserIncompatible }">
          <div class="tip-icon">
            <i :class="invalidCaptureType || isBrowserIncompatible ? 'el-icon-warning' : 'el-icon-info-circle'"></i>
          </div>
          <div class="tip-content">
            <h3>{{ getSystemAudioTipTitle }}</h3>
            <p>{{ systemAudioTipText }}</p>
            <div v-if="isBrowserIncompatible" class="browser-recommendation">
              <span>Recommended Browser:</span>
              <div class="browser-icons">
                <div class="browser-icon" @click="openBrowserRecommendation">
                  <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/chrome/chrome-original.svg"
                    alt="Chrome" />
                  <span>Chrome</span>
                </div>
              </div>
            </div>
          </div>
          <div class="tip-close" @click="showSystemAudioTip = false">
            <i class="el-icon-close"></i>
          </div>
        </div>
      </div>
    </transition>

    <div class="stopradio" v-show="radiostatus == 'stopradio'">
      <div class="waveform">
        <canvas ref="waveformCanvas_R" width="1800" height="100"></canvas>
        <audio ref="audioPlayer" :src="audioUrl" @timeupdate="onTimeUpdate" @ended="onAudioEnded"></audio>
      </div>
      <div>
        <span>{{ formatTime(currentTime) }} / {{ formatTime(elapsedTime) }}</span>
      </div>
      <div class="controls">
        <div @click="togglePlay()" class="record-button">
          <i v-if="!isPlaying" class="el-icon-video-play"></i>
          <i v-else class="el-icon-video-pause"></i>
        </div>
        <div @click="clearRecording" v-if="false" class="clear-button" :disabled="!audioUrl">
          Clear
        </div>

      </div>
      <div class="overaudiobox">

        <div class="modal-content">
          <!-- <div class="recordtitle">
            <label for="recordtitle">Enter a Title:</label>
            <input placeholder="Please enter a title for the recording" v-model="recordtitle" clearable />
          </div>
          <selectlanguage :chooeseLanguage="chooeseLanguage" :chooeseLanguageName="chooeseLanguageName"
            @chooeselanguage="chooeselanguage" /> -->

          <button v-loading="isloading" element-loading-spinner="el-icon-loading" :element-loading-text="loadingText"
            element-loading-background="rgba(21, 23, 32, 0.8)" @click="generateNotes" class="generate-notes-button"
            :disabled="!audioUrl">
            Generate Notes
            <i class="el-icon-arrow-right"></i>
          </button>
        </div>


        <span :class="{ tipred: true, shake: tipredshow }" v-if="tipredshow">The recording is less than 1 minute</span>
        <span :class="{ tipred: true, shake: uploadstatus == 'error' }" v-if="uploadstatus == 'error'"><i
            class="el-icon-warning"></i>Upload fail. Save audio locally. <br> Retry later
          with a better network connection. </span>


        <el-button v-if="uploadstatus == 'error' || tipredshow" @click="downloadAudio"
          class="clear-button download-button" :disabled="!audioUrl || uploadstatus == 'uploading'">
          Save audio locally
        </el-button>

      </div>

    </div>
    <!-- <div class="tipbox">
      Tips:<br>Do not close the tab while your recording is in progress. <br>
      For best results, please record in a quiet area and position your device close to the sound.
    </div> -->
    <!-- <div class="qiehuan">
      <el-button :disabled="isRecording" @click="gorealradio">GO实时识别语音页</el-button>
    </div> -->
  </div>
</template>

<script>
import IndexedDBAudioStorage from "@/assets/js/indexedDB.js";
import {
  // BrowserDetector, 
  TipHelper,
  // CompatibilityChecker,
  // RECOMMENDED_BROWSERS,
} from "@/utils/browserTips.js";
// import selectlanguage from "@/views/pages/home_page/popups/selectlanguage.vue";
export default {
  components: {
    // selectlanguage,
  },
  props: {
    uploadProgress: {
      type: Number,
      default: 0,
    },
    uploadstatus: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // 配置常量 - 避免魔法数字
      CONFIG: {
        CHUNK_INTERVAL: 60000, // 60秒    // 每60秒保存一次数据块
        AUDIO_CHUNK_DURATION: 30000, // 30秒    // 每30秒保存一次数据块
        BUFFER_SIZE: 4096,   // 缓冲区大小
        MIN_RECORDING_TIME: 60, // 最短录音时间（秒）
        SAFARI_TIMESLICE: {
          OLD: 30000, // 旧版Safari 30秒
          NEW: 10000  // 新版Safari 10秒
        },
        SAMPLE_RATES: {
          DEFAULT: 48000, // 默认采样率
          SAFARI_18_PLUS: 44100, // Safari 18+采样率
          SYSTEM_AUDIO: 44100 // 系统音频采样率
        },
        STATUS_CHECK_INTERVAL: 30000, // 30秒检查一次录音状态
        DATA_CHECK_TIMEOUT: 120000, // 2分钟未收到数据块则重启
        MAX_BUFFER_SIZE: 1000, // 系统录音缓冲区最大数量
        CANVAS: {
          WIDTH: 1800, // 画布宽度
          HEIGHT: 100 // 画布高度
        }
      },

      isSystemAudio: false,
      audio_img: require("@/assets/images/index/icons/1.png"),

      isRecording: false,
      isPaused: false,
      mediaRecorder: null,
      audioStream: null,
      audioChunks: [],
      audioUrl: null,
      startTime: 0,
      elapsedTime: 0,
      pauseTime: 0,
      timer: null,
      audioContext: null,
      analyser: null,
      dataArray: null,
      canvasContext: null,
      animationFrame: null,
      // notradio  stopradio
      radiostatus: "notradio",
      isPlaying: false,
      currentTime: 0,
      progress: 0,
      playbackAnalyser: null,
      playbackDataArray: null,
      playbackAnimationFrame: null,
      playaudioContext: null,
      audioSource: null,

      isloading: false,
      tipredshow: false,

      chunks: [],
      chunkInterval: 60000, // 保留向后兼容，但使用 CONFIG.CHUNK_INTERVAL
      chunkCounter: 0,
      maxrecordtime: 180, // 3 hours (180 minutes)
      mtype: 0,
      lastChunkTime: 0, // 上次接收数据块的时间

      recordtitle: "",

      chooeseLanguage: "",
      chooeseLanguageName: "",

      // 系统录音相关属性
      audioProcessor: null,
      audioDestination: null,
      bufferSize: 4096, // 保留向后兼容，但使用 CONFIG.BUFFER_SIZE

      // 系统内录音提示相关
      showSystemAudioTip: false,
      systemAudioTipText: "",
      invalidCaptureType: false,
      isBrowserIncompatible: false,

      // 系统内录音数据累积相关
      systemAudioBuffers: [], // 存储系统录音的原始音频数据
      systemAudioSampleRate: 44100, // 采样率
      systemAudioChannels: 2, // 声道数
      audioChunkDuration: 30000, // 保留向后兼容，但使用 CONFIG.AUDIO_CHUNK_DURATION
      lastSaveTime: 0, // 上次保存时间
    };
  },
  computed: {
    formattedTime() {
      const minutes = Math.floor(this.elapsedTime / 60);
      const seconds = this.elapsedTime % 60;
      return `${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`;
    },
    loadingText() {
      return `Uploading... ${this.uploadProgress}%`;
    },
    islangtime() {
      return this.elapsedTime > 60 * this.maxrecordtime;
    },
    // 添加缺失的计算属性
    getSystemAudioTipTitle() {
      if (this.invalidCaptureType) {
        return 'Browser Tab Only';
      } else if (this.isBrowserIncompatible) {
        return 'Browser Not Compatible';
      } else {
        return 'Recording Tip';
      }
    }
  },
  mounted() {
    this.canvasContext = this.$refs.waveformCanvas.getContext("2d");
    this.playbackCanvasContext = this.$refs.waveformCanvas_R.getContext("2d");

    this.mtype = this.$cookies.get("m_tkn", 0);
    if (this.mtype == 0) {
      this.maxrecordtime = 60;
    } else {
      this.maxrecordtime = 180;
    }

    // 进页面清理cookie中的录音状态标记
    this.$cookies.set('ischilddeep', '');

    // 清理 IndexedDB 中的旧录音数据，确保每次进入都是全新的录音环境
    this.clearStoredAudioData();

    // 检测浏览器类型
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) {
      // 检查IndexedDB支持
      if (window.indexedDB) {

        // 检查存储状态
        if (navigator.storage && navigator.storage.estimate) {
          navigator.storage.estimate().then(estimate => {
            console.log(`[初始化] Safari存储状态: 已用=${estimate.usage}字节, 配额=${estimate.quota}字节, 使用率=${(estimate.usage / estimate.quota * 100).toFixed(2)}%`);
          });
        } else {
          console.log("[初始化] Safari不支持storage.estimate API");
        }
      } else {
        console.warn("[初始化] Safari不支持IndexedDB");
      }
    }
  },
  methods: {
    chooeselanguage(language, Languagename) {
      this.chooeseLanguage = language
      this.chooeseLanguageName = Languagename
      this.$emit("chooeselanguage", language, Languagename);
    },
    gorealradio() {
      this.$parent.showhome = 'realradio';
    },
    backhomepage() {
      this.$emit("backhomepage");
    },
    togglePlay() {
      if (this.isPlaying) {
        this.$refs.audioPlayer.pause();
        cancelAnimationFrame(this.playbackAnimationFrame);
      } else {
        this.$refs.audioPlayer
          .play()
          .then(() => {
            // 确保分析器设置正确
            if (!this.audioSource || !this.playbackAnalyser) {
              this.setupPlaybackAnalyser();
            }
            this.drawPlaybackWaveform();
          })
          .catch((error) => {
            console.error("Error playing audio:", error);
          });
      }
      this.isPlaying = !this.isPlaying;
    },
    formatTime(time) {
      const minutes = Math.floor(time / 60);
      const seconds = Math.floor(time % 60);
      return `${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`;
    },
    onAudioEnded() {
      this.isPlaying = false;
      cancelAnimationFrame(this.playbackAnimationFrame);
    },
    onTimeUpdate(e) {
      this.currentTime = e.target.currentTime;
    },
    async toggleRecording() {
      if (!this.isRecording && !this.isPaused) {
        await this.startRecording();
      } else if (this.isRecording && !this.isPaused) {
        this.pauseRecording();
        // 暂停时关闭提示
        this.showSystemAudioTip = false;
      } else if (this.isPaused) {
        this.resumeRecording();
      }
    },
    async startRecording() {

      if (this.isBrowserIncompatible) {
        this.$message.error('Your browser does not support system audio recording. Please use Chrome browser.');
        return;
      }
      if (this.radiostatus != "startradio") {
        this.radiostatus = "startradio";
      }
      try {
        if (this.isSystemAudio) {
          await this.startSystemAudioRecording();
        } else {
          await this.startMicrophoneRecording();
        }

        // 设置定时器，每秒更新已录制的时长
        if (this.timer) {
          clearInterval(this.timer);
        }
        this.timer = setInterval(() => {
          this.elapsedTime = Math.floor((Date.now() - this.startTime) / 1000);

          // 每30秒记录一次状态
          if (this.elapsedTime % 30 === 0 && this.elapsedTime > 0) {
            if (this.isSystemAudio) {
              console.log(`[系统录音] 录音进行中: 已录制${this.elapsedTime}秒, 数据块数=${this.chunkCounter}, 缓冲区长度=${this.systemAudioBuffers.length}`);
              
              // 检查系统录音是否正常工作
              if (this.systemAudioBuffers.length === 0 && this.chunkCounter === 0 && this.elapsedTime > 30) {
                console.warn(`[系统录音] 警告: 录音${this.elapsedTime}秒但未收到任何音频数据`);
              }
            } else {
              console.log(`[录音] 录音进行中: 已录制${this.elapsedTime}秒, 数据块数=${this.chunkCounter}, 模式=麦克风录音`);

              // 检查浏览器类型
              const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
              if (isSafari) {
                console.log(`[录音] 当前是Safari浏览器`);

                // 检查存储状态
                if (navigator.storage && navigator.storage.estimate) {
                  navigator.storage.estimate().then(estimate => {
                    const usageRatio = estimate.usage / estimate.quota;
                    console.log(`[录音] Safari存储状态: 已用=${estimate.usage}字节, 配额=${estimate.quota}字节, 使用率=${(usageRatio * 100).toFixed(2)}%`);
                  });
                }

                // 检查是否长时间没有收到数据块
                this.checkDataChunks();
              }
            }
          }

          if (this.islangtime) {
            console.log(`[录音] 达到最大录制时长: ${this.maxrecordtime}分钟`);
            this.openvipchaoxian();
            this.stopRecording();
          }
        }, 1000);

        // 绘制波形图
        this.drawWaveform();
      } catch (err) {
        // 如果获取音频失败，恢复到notradio状态
        this.radiostatus = "notradio";

        // 如果是系统内录音且已有特定提示，则显示提示
        if (this.isSystemAudio && this.showSystemAudioTip) {
          // 提示由startSystemAudioRecording方法设置，这里不需要额外设置
        } else {
          // 通用错误
          this.showSystemAudioTip = true;
          this.systemAudioTipText = 'Failed to start recording. Please check your microphone settings and try again.';
        }

        console.error(`[录音] ${this.isSystemAudio ? '系统内录音' : '麦克风录音'}出错:`, err);
      }
    },
    pauseRecording() {
      if (this.isRecording && !this.isPaused) {
        // 设置暂停状态
        this.isPaused = true;
        this.isRecording = false;
        clearInterval(this.timer);
        this.pauseTime = Date.now();

        // 处理不同录音模式的暂停逻辑
        if (this.isSystemAudio) {
          // 系统内录音暂停 - 保存当前缓冲区数据并暂停音频上下文处理
          this.pauseSystemAudioRecording();
        } else {
          // 麦克风录音暂停
          if (this.mediaRecorder && this.mediaRecorder.state === 'recording') {
            console.log("[录音] 暂停媒体录制器");
            this.mediaRecorder.pause();
          }
        }

        // 停止波形动画
        if (this.animationFrame) {
          console.log("[录音] 停止波形动画");
          cancelAnimationFrame(this.animationFrame);
          this.animationFrame = null;
        }

        // 清空画布
        const canvas = this.$refs.waveformCanvas;
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = "#15171f";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
      }
    },
    // 暂停系统内录音
    async pauseSystemAudioRecording() {
      try {
        // 先保存当前缓冲区的数据
        if (this.systemAudioBuffers.length > 0) {
          await this.saveSystemAudioChunk();
        }
        
        // 暂停音频上下文
        if (this.audioContext && this.audioContext.state === 'running') {
          console.log("[系统录音] 暂停音频上下文");
          await this.audioContext.suspend();
        }
      } catch (error) {
        console.error("[系统录音] 暂停录音时出错:", error);
      }
    },
    resumeRecording() {
      if (this.isPaused) {
        // 设置恢复录音状态
        this.isPaused = false;
        this.isRecording = true;
        this.startTime += Date.now() - this.pauseTime;

        // 处理不同录音模式的恢复逻辑
        if (this.isSystemAudio) {
          // 系统内录音恢复 - 恢复音频上下文处理
          this.resumeSystemAudioRecording();
        } else {
          // 麦克风录音恢复
          if (this.mediaRecorder && this.mediaRecorder.state === 'paused') {
            console.log("[录音] 恢复媒体录制器");
            this.mediaRecorder.resume();
          }

          // 恢复音频上下文
          if (this.audioContext && this.audioContext.state === 'suspended') {
            this.audioContext.resume()
              .then(() => {
                // 确保波形图重新开始绘制
                if (!this.animationFrame) {
                  this.drawWaveform();
                }
              })
              .catch(error =>
                console.error("[录音] 恢复音频上下文失败:", error)
              );
          } else {
            // 如果音频上下文不是suspended状态，直接重启波形图
            if (!this.animationFrame) {
              this.drawWaveform();
            }
          }
        }

        // 重新启动计时器
        if (this.timer) {
          clearInterval(this.timer);
        }
        this.timer = setInterval(() => {
          this.elapsedTime = Math.floor((Date.now() - this.startTime) / 1000);
          if (this.islangtime) {
            this.openvipchaoxian();
            this.stopRecording();
          }
        }, 1000);
      }
    },
    // 恢复系统内录音
    async resumeSystemAudioRecording() {
      try {
        // 恢复音频上下文
        if (this.audioContext && this.audioContext.state === 'suspended') {
          console.log("[系统录音] 恢复音频上下文");
          await this.audioContext.resume();
        }
        
        // 重置保存时间，准备新的数据累积周期
        this.lastSaveTime = Date.now();
        
        // 确保波形图重新开始绘制
        if (!this.animationFrame) {
          this.drawWaveform();
        }
      } catch (error) {
        console.error("[系统录音] 恢复录音时出错:", error);
      }
    },
    stopRecording() {
      console.log(`[录音] 停止${this.isSystemAudio ? '系统内' : '麦克风'}录音: 已录制${this.elapsedTime}秒, 数据块数=${this.chunkCounter}`);
      this.radiostatus = "stopradio";

      // 清理cookie中的录音状态标记
      this.$cookies.set('ischilddeep', '');

      this.pauseTime = 0;
      this.isRecording = false;
      this.isPaused = false;
      clearInterval(this.timer);
      cancelAnimationFrame(this.animationFrame);

      // 停止录音时关闭提示
      this.showSystemAudioTip = false;

      if (this.isSystemAudio) {
        // 系统内录音模式的停止逻辑
        this.stopSystemAudioRecording();
      } else {
        // 麦克风录音模式的停止逻辑
        if (this.mediaRecorder) {
          console.log(`[录音] 停止媒体录制器: 状态=${this.mediaRecorder.state}`);
          this.mediaRecorder.stop();
          this.mediaRecorder.onstop = () => {
            // 关闭麦克风
            if (this.audioStream) {
              console.log("[录音] 关闭音频流");
              this.audioStream.getTracks().forEach(track => track.stop());
            }
          };
        }
        this.mediaRecorder = null;
        this.stream = null;
        if (this.audioContext && this.audioContext.state !== "closed") {
          console.log(`[录音] 关闭音频上下文: 状态=${this.audioContext.state}`);
          this.audioContext
            .close()
            .catch((error) =>
              console.error("[录音] 关闭音频上下文错误:", error)
            );
        }
        if (this.analyser) {
          console.log("[录音] 断开分析器");
          this.analyser.disconnect();
          this.analyser = null;
        }
        this.audioContext = null;
      }
    },

    // 停止系统内录音的异步方法
    async stopSystemAudioRecording() {
      try {
        // 保存最后剩余的音频数据
        if (this.systemAudioBuffers.length > 0) {
          await this.saveSystemAudioChunk();
        }
        
        if (this.audioProcessor) {
          this.audioProcessor.disconnect();
        }
        if (this.audioSource) {
          this.audioSource.disconnect();
        }
        if (this.audioStream) {
          this.audioStream.getTracks().forEach(track => track.stop());
        }
        if (this.audioContext && this.audioContext.state !== "closed") {
          await this.audioContext.close().catch(error =>
            console.error("[系统录音] 关闭音频上下文错误:", error)
          );
        }
        // 完成录音处理
        this.finalizeRecording();
      } catch (error) {
        console.error("[系统录音] 停止录音时出错:", error);
        // 即使出错也要完成录音处理
        this.finalizeRecording();
      }
    },
    async clearRecording() {
      console.log("[录音] 清理录音");
      this.audioUrl = null;
      this.elapsedTime = 0;
      this.tipredshow = false;
      this.pauseTime = 0;
      this.isPlaying = false;
      this.isPaused = false;
      this.currentTime = 0;
      this.progress = 0;
      this.audioChunks = [];
      this.$parent.uploadstatus = '';
      this.showSystemAudioTip = false; // 关闭任何提示

      // 清理系统录音缓冲区
      this.systemAudioBuffers = [];
      this.lastSaveTime = 0;

      // 清理录音相关资源
      this.canvasContext.clearRect(
        0,
        0,
        this.$refs.waveformCanvas.width,
        this.$refs.waveformCanvas.height
      );
      if (this.mediaRecorder) {
        console.log("[录音] 停止媒体录制器");
        this.mediaRecorder.stop();
        this.mediaRecorder.onstop = () => {
          // 关闭麦克风
          if (this.audioStream) {
            console.log("[录音] 关闭音频流");
            this.audioStream.getTracks().forEach(track => track.stop());
          }
        };
      }
      this.mediaRecorder = null;
      this.stream = null;
      // 清理 IndexedDB 中的数据
      console.log("[IndexedDB] 清理数据库");
      await IndexedDBAudioStorage.clearDB();
      console.log("[IndexedDB] 数据库清理完成");

      if (this.audioContext && this.audioContext.state !== "closed") {
        console.log(`[录音] 关闭音频上下文: 状态=${this.audioContext.state}`);
        this.audioContext
          .close()
          .catch((error) =>
            console.error("[录音] 关闭音频上下文错误:", error)
          );
      }
      if (this.analyser) {
        console.log("[录音] 断开分析器");
        this.analyser.disconnect();
        this.analyser = null;
      }
      this.cleanupAudioContext();
      this.radiostatus = "notradio";
    },
    cleanupAudioContext() {
      // 使用新的清理方法
      this.cleanupPlaybackResources();

      // 清理 AudioContext
      if (this.playaudioContext && this.playaudioContext.state !== "closed") {
        this.playaudioContext
          .close()
          .catch((error) =>
            console.error("Error closing audio context:", error)
          );
      }

      this.$refs?.audioPlayer?.pause();

      this.playaudioContext = null;
      // 重置其他相关状态
      this.playbackDataArray = null;

      // 停止所有动画帧
      cancelAnimationFrame(this.animationFrame);
      cancelAnimationFrame(this.playbackAnimationFrame);
    },
    async downloadAudio() {
      if (this.audioUrl) {
        const a = document.createElement("a");
        a.href = this.audioUrl;

        // 根据录音类型决定下载文件的扩展名
        let extension = '.webm';
        if (this.isSystemAudio && this.chunks.length > 0 && this.chunks[0].type === 'audio/wav') {
          extension = '.wav';
        }

        a.download = "audio_" + Date.now() + extension;
        a.click();
      }
      // await IndexedDBAudioStorage.clearDB();
    },
    async generateNotes() {

      // if (this.recordtitle == "") {
      //   this.$message.error("Please enter a title.");
      //   return;
      // }

      // if (this.chooeseLanguage == "") {
      //   this.$message.error("Please select a language.");
      //   return;
      // }
      // 检查网络连接
      if (!navigator.onLine) {
        this.$message({
          type: 'warning',
          message: 'No internet connection. Your recording will be saved locally.',
          duration: 5000
        });
        this.$parent.uploadstatus = 'error';
        return;
      }

      console.log(`[IndexedDB] 开始获取所有数据块用于上传`);
      const chunks = await IndexedDBAudioStorage.getAllChunks();
      console.log(`[IndexedDB] 获取数据块完成: 总块数=${chunks ? chunks.length : 0}, 预期块数=${this.chunkCounter}`);

      if (!chunks || chunks.length === 0) {
        console.error("[IndexedDB] 没有录音数据可上传");
        return;
      }

      if (this.elapsedTime < 60) {
        this.tipredshow = true;
        //英文
        this.$message.error("The recording time is less than 60 seconds. Please try recording again.");
        return;
      }

      // 创建音频 blob 前先验证所有 chunks 是否完整
      let totalSize = 0;
      chunks.forEach(chunk => totalSize += chunk.size);
      console.log(`[IndexedDB] 音频总大小: ${totalSize}字节, 约${(totalSize / 1024 / 1024).toFixed(2)}MB`);

      if (totalSize === 0) {
        console.error("[IndexedDB] 录音数据已损坏");
        this.$message.error("Recording is corrupted. Please try recording again.");
        return;
      }

      this.isloading = true;

      let audioBlob, mimeType;

      // 检查是否为系统内录音的WAV数据
      if (this.isSystemAudio && chunks[0] && chunks[0].type === 'audio/wav') {
        console.log(`[系统录音] 合并WAV数据用于上传`);
        try {
          // 使用WAV合并方法处理数据
          audioBlob = await this.mergeWavChunks(chunks);
          mimeType = 'audio/wav';
          console.log(`[系统录音] 合并WAV数据完成: 大小=${audioBlob.size}字节`);
        } catch (error) {
          console.error(`[系统录音] 合并WAV数据失败:`, error);
          // 如果合并失败，尝试使用普通方式合并
          audioBlob = new Blob(chunks, { type: 'audio/wav' });
          mimeType = 'audio/wav';
        }
      } else {
        // 麦克风录音或其他非WAV系统录音使用webm格式
        audioBlob = new Blob(chunks, { type: 'audio/webm' });
        mimeType = 'audio/webm';
        console.log(`[IndexedDB] 创建Blob完成: 大小=${audioBlob.size}字节, 类型=${audioBlob.type}, 录音时长=${this.elapsedTime}秒`);
      }

      // 根据实际格式设置文件扩展名
      const extension = mimeType === 'audio/wav' ? '.wav' : '.webm';
      let name = "";
      if (this.recordtitle != "") {
        name = this.recordtitle + extension;
      } else {
        name = "audio_" + Date.now() + extension;
      }

      const file = new File([audioBlob], name, { type: mimeType });
      console.log(`[IndexedDB] 创建File完成: 名称=${name}, 大小=${file.size}字节, 类型=${mimeType}`);
      try {
        // 发送上传请求
        console.log(`[IndexedDB] 开始上传文件: 名称=${name}, 大小=${file.size}字节, 录音时长=${this.elapsedTime}秒`);
        this.$emit("upload_audio", 'audio', file, name, this.elapsedTime);

      } catch (error) {
        console.error("[IndexedDB] 上传过程中出错:", error);
        this.$message({
          type: 'error',
          message: 'Upload failed. Your recording has been saved locally.',
          duration: 5000
        });

        this.$parent.uploadstatus = 'error';
        this.isloading = false;
      }
    },
    setupPlaybackAnalyser() {
      try {
        // 如果已经有音频源且状态正常，直接返回
        if (this.audioSource && this.playbackAnalyser && this.playaudioContext && this.playaudioContext.state !== "closed") {
          console.log("[播放] 分析器已存在且正常，跳过重新创建");
          return;
        }

        // 清理现有资源
        this.cleanupPlaybackResources();

        // 创建或恢复音频上下文
        if (!this.playaudioContext || this.playaudioContext.state === "closed") {
          this.playaudioContext = new (window.AudioContext ||
            window.webkitAudioContext)();
        }

        if (this.playaudioContext.state === "suspended") {
          this.playaudioContext.resume();
        }

        // 创建新的分析器
        this.playbackAnalyser = this.playaudioContext.createAnalyser();
        this.playbackAnalyser.fftSize = 2048;

        // 创建新的音频源并连接
        this.audioSource = this.playaudioContext.createMediaElementSource(
          this.$refs.audioPlayer
        );
        this.audioSource.connect(this.playbackAnalyser);
        this.playbackAnalyser.connect(this.playaudioContext.destination);

        this.playbackDataArray = new Uint8Array(
          this.playbackAnalyser.frequencyBinCount
        );

        console.log("[播放] 音频分析器设置完成");
      } catch (error) {
        console.error("[播放] 设置音频分析器错误:", error);
        // 如果创建失败，尝试清理并重新创建音频元素
        if (error.name === 'InvalidStateError' && error.message.includes('already connected')) {
          console.log("[播放] 检测到重复连接错误，尝试重新创建音频元素");
          this.recreateAudioElement();
        }
      }
    },

    // 新增方法：清理播放相关资源
    cleanupPlaybackResources() {
      // 断开现有连接
      if (this.audioSource) {
        try {
          this.audioSource.disconnect();
        } catch (e) {
          console.log("[播放] 断开音频源连接时出错:", e.message);
        }
        this.audioSource = null;
      }

      if (this.playbackAnalyser) {
        try {
          this.playbackAnalyser.disconnect();
        } catch (e) {
          console.log("[播放] 断开分析器连接时出错:", e.message);
        }
        this.playbackAnalyser = null;
      }

      // 停止动画帧
      if (this.playbackAnimationFrame) {
        cancelAnimationFrame(this.playbackAnimationFrame);
        this.playbackAnimationFrame = null;
      }
    },

    // 新增方法：重新创建音频元素
    recreateAudioElement() {
      try {
        const audioPlayer = this.$refs.audioPlayer;
        if (audioPlayer) {
          const currentSrc = audioPlayer.src;
          const currentTime = audioPlayer.currentTime;
          const wasPlaying = !audioPlayer.paused;

          // 暂停并重置音频元素
          audioPlayer.pause();
          audioPlayer.src = '';
          audioPlayer.load();

          // 重新设置源
          setTimeout(() => {
            audioPlayer.src = currentSrc;
            audioPlayer.currentTime = currentTime;

            if (wasPlaying) {
              audioPlayer.play().then(() => {
                // 重新设置分析器
                this.setupPlaybackAnalyser();
                this.drawPlaybackWaveform();
              }).catch(error => {
                console.error("[播放] 重新播放音频时出错:", error);
              });
            } else {
              // 重新设置分析器
              this.setupPlaybackAnalyser();
            }
          }, 100);
        }
      } catch (error) {
        console.error("[播放] 重新创建音频元素时出错:", error);
      }
    },
    drawPlaybackWaveform() {
      if (!this.playbackAnalyser) return;

      this.playbackAnalyser.getByteTimeDomainData(this.playbackDataArray);

      const canvas = this.$refs.waveformCanvas_R;
      const canvasCtx = canvas.getContext("2d");
      const width = canvas.width;
      const height = canvas.height;

      canvasCtx.fillStyle = "#15171f";
      canvasCtx.fillRect(0, 0, width, height);

      canvasCtx.lineWidth = 2;
      canvasCtx.strokeStyle = "#ff4444";
      canvasCtx.beginPath();

      const sliceWidth = (width * 1.0) / this.playbackDataArray.length;
      let x = 0;

      for (let i = 0; i < this.playbackDataArray.length; i++) {
        const v = this.playbackDataArray[i] / 128.0;
        const y = (v * height) / 2;

        if (i === 0) {
          canvasCtx.moveTo(x, y);
        } else {
          canvasCtx.lineTo(x, y);
        }

        x += sliceWidth;
      }

      canvasCtx.lineTo(width, height / 2);
      canvasCtx.stroke();

      if (this.isPlaying) {
        this.playbackAnimationFrame = requestAnimationFrame(
          this.drawPlaybackWaveform
        );
      }
    },
    drawWaveform() {

      if (!this.analyser) return;

      this.analyser.getByteTimeDomainData(this.dataArray);
      this.canvasContext.fillStyle = "#15171f";
      this.canvasContext.fillRect(
        0,
        0,
        this.$refs.waveformCanvas.width,
        this.$refs.waveformCanvas.height
      );

      this.canvasContext.lineWidth = 2;
      this.canvasContext.strokeStyle = "#ff4444";
      this.canvasContext.beginPath();

      const sliceWidth =
        (this.$refs.waveformCanvas.width * 1.0) /
        this.analyser.frequencyBinCount;
      let x = 0;

      for (let i = 0; i < this.analyser.frequencyBinCount; i++) {
        const v = this.dataArray[i] / 128.0;
        const y = (v * this.$refs.waveformCanvas.height) / 2;

        if (i === 0) {
          this.canvasContext.moveTo(x, y);
        } else {
          this.canvasContext.lineTo(x, y);
        }

        x += sliceWidth;
      }

      this.canvasContext.lineTo(
        this.$refs.waveformCanvas.width,
        this.$refs.waveformCanvas.height / 2
      );
      this.canvasContext.stroke();

      this.animationFrame = requestAnimationFrame(this.drawWaveform);
    },

    async saveChunk(chunk) {
      try {
        // console.log(`[IndexedDB] 保存数据块: 大小=${chunk.size}字节, 总块数=${this.chunkCounter}`);
        await IndexedDBAudioStorage.saveChunk(chunk);
        // console.log(`[IndexedDB] 数据块保存成功: 块ID=${this.chunkCounter}`);
      } catch (error) {
        console.error(`[IndexedDB] 保存数据块错误: 块ID=${this.chunkCounter}, 错误=`, error);
        // 可以在这里添加错误处理逻辑，比如通知用户
        // this.$message.error("保存录音片段时出错，请检查您的设备存储空间。");
      }
    },

    async finalizeRecording() {
      try {
        console.log(`[IndexedDB] 开始获取所有数据块`);
        const chunks = await IndexedDBAudioStorage.getAllChunks();
        console.log(`[IndexedDB] 获取数据块完成: 总块数=${chunks ? chunks.length : 0}, 预期块数=${this.chunkCounter}`);

        // 检查是否有数据块
        if (!chunks || chunks.length === 0) {
          console.error("[IndexedDB] 没有录音数据可用");
          // 如果没有数据块但有录音时长，可能是Safari浏览器的问题
          if (this.elapsedTime > 60 && this.mediaRecorder) {
            console.log("[录音] 尝试最后请求一次数据");
            try {
              // 最后尝试请求一次数据
              this.mediaRecorder.requestData();

              // 等待一段时间后再次检查
              setTimeout(async () => {
                const finalChunks = await IndexedDBAudioStorage.getAllChunks();
                if (finalChunks && finalChunks.length > 0) {
                  this.processFinalChunks(finalChunks);
                } else {
                  console.error("[录音] 无法获取任何录音数据");
                  this.$message.error("录音失败，未能获取到任何音频数据");
                }
              }, 1000);
            } catch (error) {
              console.error("[录音] 最后请求数据错误:", error);
            }
          }
          return;
        }

        this.processFinalChunks(chunks);
      } catch (error) {
        console.error("[IndexedDB] 处理录音时出错:", error);
        // this.$message.error("处理录音时出错，请稍后重试。");
      }
    },

    // 处理最终的数据块
    processFinalChunks(chunks) {
      // 计算总大小
      let totalSize = 0;
      chunks.forEach(chunk => totalSize += chunk.size);
      console.log(`[IndexedDB] 音频总大小: ${totalSize}字节, 约${(totalSize / 1024 / 1024).toFixed(2)}MB`);

      // 检查数据大小是否合理
      if (totalSize < 1000 && this.elapsedTime > 60) {
        console.warn(`[录音] 警告: 录音数据大小(${totalSize}字节)异常小，可能录音失败`);
      }

      // 检查是否为系统内录音模式
      if (this.isSystemAudio) {
        console.log(`[系统录音] 处理系统内录音数据: 块数=${chunks.length}`);

        // 系统录音模式下，检查第一个块是否为WAV格式
        const firstChunk = chunks[0];
        if (firstChunk && firstChunk.type === 'audio/wav') {
          // 如果是多个WAV文件，需要合并处理
          this.mergeWavChunks(chunks).then(audioBlob => {
            console.log(`[系统录音] 合并WAV数据完成: 大小=${audioBlob.size}字节`);
            this.audioUrl = URL.createObjectURL(audioBlob);
            console.log(`[系统录音] 创建URL完成: ${this.audioUrl}`);
          }).catch(error => {
            console.error(`[系统录音] 合并WAV数据失败:`, error);
            // 如果合并失败，尝试使用第一个块作为音频
            this.audioUrl = URL.createObjectURL(firstChunk);
          });
        } else {
          // 如果不是WAV格式，使用普通的Blob合并
          const audioBlob = new Blob(chunks, { type: 'audio/webm' });
          console.log(`[系统录音] 创建普通Blob完成: 大小=${audioBlob.size}字节, 类型=${audioBlob.type}`);
          this.audioUrl = URL.createObjectURL(audioBlob);
          console.log(`[系统录音] 创建URL完成: ${this.audioUrl}`);
        }
      } else {
        // 原始的麦克风录音模式处理方式
        const audioBlob = new Blob(chunks, { type: 'audio/webm' });
        console.log(`[IndexedDB] 创建Blob完成: 大小=${audioBlob.size}字节, 类型=${audioBlob.type}`);
        this.audioUrl = URL.createObjectURL(audioBlob);
        console.log(`[IndexedDB] 创建URL完成: ${this.audioUrl}`);
      }
    },

    // 合并多个WAV数据块
    mergeWavChunks(chunks) {
      return new Promise((resolve, reject) => {
        try {
          console.log(`[系统录音] 开始合并${chunks.length}个WAV数据块`);

          // 如果只有一个块，直接返回
          if (chunks.length === 1) {
            resolve(chunks[0]);
            return;
          }

          // 将所有块转换为ArrayBuffer
          Promise.all(chunks.map(chunk =>
            new Promise((resolve) => {
              const reader = new FileReader();
              reader.onload = () => resolve(reader.result);
              reader.readAsArrayBuffer(chunk);
            })
          )).then(buffers => {
            try {
              // 解析第一个WAV头部信息，获取基本信息
              const firstBuffer = buffers[0];
              const view = new DataView(firstBuffer);

              // 检查是否是有效的WAV文件
              const riff = this.readString(view, 0, 4);
              const wave = this.readString(view, 8, 4);
              if (riff !== 'RIFF' || wave !== 'WAVE') {
                throw new Error('无效的WAV文件格式');
              }

              // 读取格式信息
              let offset = 12; // 跳过RIFF和WAVE头
              while (offset < view.byteLength) {
                const chunkType = this.readString(view, offset, 4);
                const chunkSize = view.getUint32(offset + 4, true);

                if (chunkType === 'fmt ') {
                  // 获取音频参数
                  const audioFormat = view.getUint16(offset + 8, true);
                  const numChannels = view.getUint16(offset + 10, true);
                  const sampleRate = view.getUint32(offset + 12, true);
                  const byteRate = view.getUint32(offset + 16, true);
                  const blockAlign = view.getUint16(offset + 20, true);
                  const bitsPerSample = view.getUint16(offset + 22, true);

                  console.log(`[系统录音] WAV格式信息: 通道=${numChannels}, 采样率=${sampleRate}, 位深=${bitsPerSample}`);

                  // 提取所有数据块中的纯音频数据
                  const audioDataChunks = [];
                  let totalAudioDataLength = 0;

                  for (let i = 0; i < buffers.length; i++) {
                    const buffer = buffers[i];
                    const chunkView = new DataView(buffer);
                    let chunkOffset = 12; // 跳过RIFF和WAVE头

                    while (chunkOffset < chunkView.byteLength) {
                      const type = this.readString(chunkView, chunkOffset, 4);
                      const size = chunkView.getUint32(chunkOffset + 4, true);

                      if (type === 'data') {
                        // 找到数据块，提取纯音频数据
                        const dataStart = chunkOffset + 8;
                        const audioData = buffer.slice(dataStart, dataStart + size);
                        audioDataChunks.push(audioData);
                        totalAudioDataLength += size;
                        break;
                      }

                      chunkOffset += 8 + size;
                    }
                  }

                  // 创建合并后的WAV文件
                  const resultBuffer = new ArrayBuffer(44 + totalAudioDataLength);
                  const resultView = new DataView(resultBuffer);

                  // 写入WAV头
                  this.writeString(resultView, 0, 'RIFF');
                  resultView.setUint32(4, 36 + totalAudioDataLength, true);
                  this.writeString(resultView, 8, 'WAVE');

                  // 写入fmt块
                  this.writeString(resultView, 12, 'fmt ');
                  resultView.setUint32(16, 16, true); // 格式块大小
                  resultView.setUint16(20, audioFormat, true);
                  resultView.setUint16(22, numChannels, true);
                  resultView.setUint32(24, sampleRate, true);
                  resultView.setUint32(28, byteRate, true);
                  resultView.setUint16(32, blockAlign, true);
                  resultView.setUint16(34, bitsPerSample, true);

                  // 写入data块头
                  this.writeString(resultView, 36, 'data');
                  resultView.setUint32(40, totalAudioDataLength, true);

                  // 写入合并的音频数据
                  let dataOffset = 44;
                  for (const audioData of audioDataChunks) {
                    new Uint8Array(resultBuffer).set(new Uint8Array(audioData), dataOffset);
                    dataOffset += audioData.byteLength;
                  }

                  // 创建合并后的Blob
                  const resultBlob = new Blob([resultBuffer], { type: 'audio/wav' });
                  console.log(`[系统录音] WAV合并完成: 大小=${resultBlob.size}字节`);
                  resolve(resultBlob);
                  return;
                }

                offset += 8 + chunkSize;
              }

              throw new Error('无法找到WAV格式信息');
            } catch (innerError) {
              console.error(`[系统录音] 处理WAV数据失败:`, innerError);
              reject(innerError);
            }
          }).catch(error => {
            console.error(`[系统录音] 读取WAV数据失败:`, error);
            reject(error);
          });

        } catch (error) {
          console.error(`[系统录音] 合并WAV数据失败:`, error);
          reject(error);
        }
      });
    },

    // 从DataView中读取字符串
    readString(view, offset, length) {
      let result = '';
      for (let i = 0; i < length; i++) {
        result += String.fromCharCode(view.getUint8(offset + i));
      }
      return result;
    },
    openvipchaoxian() {
      this.$emit('openvipchaoxian')
    },
    // 添加检查数据块生成的方法
    checkDataChunks() {
      // 如果已经有数据块，并且距离上次接收数据块的时间超过120秒
      if (this.mediaRecorder && this.mediaRecorder.state === "recording" &&
        this.lastChunkTime > 0 &&
        Date.now() - this.lastChunkTime > 120000) {
        console.log(`[录音] 长时间未收到数据块，尝试重新请求数据，上次接收时间: ${new Date(this.lastChunkTime).toISOString()}`);
        try {
          // 尝试请求数据
          this.mediaRecorder.requestData();

          // 如果仍然没有收到数据，可能需要重新启动录音
          setTimeout(() => {
            if (Date.now() - this.lastChunkTime > 120000) {
              console.log("[录音] 重新请求数据后仍未收到数据块，尝试重新启动录音");
              this.restartRecording();
            }
          }, 5000); // 等待5秒检查是否收到数据
        } catch (error) {
          console.error("[录音] 请求数据块错误:", error);
        }
      } else if (this.elapsedTime > 120 && this.chunkCounter === 0) {
        // 如果录音超过2分钟但没有收到任何数据块，尝试重新启动录音
        console.log("[录音] 录音超过2分钟但未收到任何数据块，尝试重新启动录音");
        this.restartRecording();
      }
    },

    // 重新启动录音的方法
    restartRecording() {
      if (!this.isRecording || this.isPaused) return;

      console.log("[录音] 重新启动录音");

      // 停止当前录音
      if (this.mediaRecorder) {
        try {
          // 停止当前录音器但不改变录音状态
          this.mediaRecorder.stop();

          // 创建新的录音器
          setTimeout(async () => {
            if (!this.isRecording) return; // 如果用户已经停止录音，则不重新启动

            try {
              // 重新创建媒体录制器
              this.mediaRecorder = new MediaRecorder(this.audioStream);

              // 重新绑定事件监听器
              this.mediaRecorder.addEventListener("dataavailable", async (event) => {
                if (event.data.size > 0) {
                  console.log(`[录音] 收到数据块: 大小=${event.data.size}字节, 块ID=${this.chunkCounter}`);
                  this.chunks.push(event.data);
                  await this.saveChunk(event.data);
                  this.chunkCounter++;
                  this.lastChunkTime = Date.now();
                }
              });

              this.mediaRecorder.addEventListener("stop", () => {
                if (this.isRecording) {
                  this.mediaRecorder.start();
                } else {
                  this.finalizeRecording();
                }
              });

              // 重新启动录音
              const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
              if (isSafari) {
                this.mediaRecorder.start();
              } else {
                this.mediaRecorder.start(this.chunkInterval);
              }

              console.log("[录音] 录音已重新启动");
            } catch (error) {
              console.error("[录音] 重新启动录音错误:", error);
              // 如果重新启动失败，恢复到停止状态
              this.stopRecording();
            }
          }, 1000);
        } catch (error) {
          console.error("[录音] 停止当前录音错误:", error);
        }
      }
    },
    async startMicrophoneRecording() {
      // 设置cookie标记录音状态，用于左侧栏点击检测
      this.$cookies.set('ischilddeep', 'islive');

      const browserInfo = this.getBrowserInfo();
      
      return this.handleAsyncOperation(async () => {
        // 获取用户音频设备
        console.log("[录音] 开始获取麦克风音频设备");
        this.audioStream = await navigator.mediaDevices.getUserMedia({ audio: true });
        console.log("[录音] 获取麦克风音频设备成功");

        console.log(`[录音] 浏览器信息: 类型=${browserInfo.isChrome ? 'Chrome' : browserInfo.isSafari ? 'Safari' : 'Other'}, Safari版本=${browserInfo.safariVersion}`);

        // 创建音频上下文 - 对于Safari 18+使用更低的采样率
        const sampleRate = browserInfo.isSafari && browserInfo.safariVersion >= 18 
          ? this.CONFIG.SAMPLE_RATES.SAFARI_18_PLUS 
          : this.CONFIG.SAMPLE_RATES.DEFAULT;
          
        const audioContextOptions = { sampleRate };

        this.audioContext = new (window.AudioContext || window.webkitAudioContext)(audioContextOptions);
        console.log(`[录音] 创建音频上下文: 采样率=${this.audioContext.sampleRate}`);

        // 创建媒体流源和分析器
        const source = this.audioContext.createMediaStreamSource(this.audioStream);
        this.analyser = this.audioContext.createAnalyser();
        this.analyser.fftSize = 2048;
        source.connect(this.analyser);
        this.dataArray = new Uint8Array(this.analyser.frequencyBinCount);

        // 创建媒体录制器
        console.log("[录音] 创建媒体录制器");
        
        const mimeType = this.getMimeType(browserInfo);
        console.log(`[录音] 使用MIME类型: ${mimeType}`);
        
        this.mediaRecorder = new MediaRecorder(this.audioStream, { mimeType });
        console.log(`[录音] 媒体录制器创建成功: 状态=${this.mediaRecorder.state}, MIME类型=${this.mediaRecorder.mimeType}`);

        // 绑定事件监听器
        this.setupMediaRecorderEvents();

        // 开始录音
        this.startMediaRecorder(browserInfo);

        this.isRecording = true;
        this.isPaused = false;

        // 记录录音开始时间
        this.recordStartTime();

        // 显示成功提示
        this.showRecordingTip();

      }, '麦克风录音');
    },

    /**
     * 获取适合当前浏览器的MIME类型
     */
    getMimeType(browserInfo) {
      let mimeType = 'audio/webm';
      
      if (MediaRecorder.isTypeSupported) {
        if (browserInfo.isSafari) {
          if (browserInfo.safariVersion >= 18) {
            // Safari 18+支持WebM和Opus
            if (MediaRecorder.isTypeSupported('audio/webm;codecs=opus')) {
              mimeType = 'audio/webm;codecs=opus';
            } else {
              mimeType = 'audio/mp4';
            }
          } else {
            // 旧版Safari只支持MP4
            mimeType = 'audio/mp4';
          }
        } else if (MediaRecorder.isTypeSupported('audio/webm;codecs=opus')) {
          mimeType = 'audio/webm;codecs=opus';
        }
      }
      
      return mimeType;
    },

    /**
     * 设置MediaRecorder事件监听器
     */
    setupMediaRecorderEvents() {
      // 监听录音数据可用的事件
      this.mediaRecorder.addEventListener("dataavailable", async (event) => {
        if (event.data.size > 0) {
          console.log(`[录音] 收到数据块: 大小=${event.data.size}字节, 块ID=${this.chunkCounter}`);
          this.chunks.push(event.data);
          await this.saveChunk(event.data);
          this.chunkCounter++;
          this.lastChunkTime = Date.now();
        } else {
          console.warn(`[录音] 收到空数据块: 块ID=${this.chunkCounter}`);
        }

        if (this.islangtime) {
          console.log(`[录音] 达到最大录制时长: ${this.maxrecordtime}分钟`);
          this.openvipchaoxian();
          this.stopRecording();
        }
      });

      // 监听录音停止的事件
      this.mediaRecorder.addEventListener("stop", () => {
        console.log("[录音] 录音停止事件触发");

        if (this.isRecording) {
          console.log("[录音] 继续录音");
          this.mediaRecorder.start();
        } else {
          console.log("[录音] 完成录音，开始处理");
          this.finalizeRecording();
        }
      });
    },

    /**
     * 启动MediaRecorder
     */
    startMediaRecorder(browserInfo) {
      console.log(`[录音] 开始录音: 块间隔=${this.CONFIG.CHUNK_INTERVAL}ms`);

      if (browserInfo.isSafari) {
        // Safari浏览器中使用较短的timeslice参数
        const timeslice = browserInfo.safariVersion >= 18 
          ? this.CONFIG.SAFARI_TIMESLICE.NEW 
          : this.CONFIG.SAFARI_TIMESLICE.OLD;
        console.log(`[录音] 检测到Safari浏览器 ${browserInfo.safariVersion}，使用${timeslice}ms的timeslice参数`);
        this.mediaRecorder.start(timeslice);
      } else {
        // 非Safari浏览器使用标准间隔
        this.mediaRecorder.start(this.CONFIG.CHUNK_INTERVAL);
      }
    },

    /**
     * 记录录音开始时间
     */
    recordStartTime() {
      if (this.pauseTime != 0) {
        this.startTime += Date.now() - this.pauseTime;
        this.pauseTime = 0;
        console.log(`[录音] 恢复录音: 开始时间=${this.startTime}`);
      } else {
        this.startTime = Date.now();
        console.log(`[录音] 新录音: 开始时间=${this.startTime}`);
      }
    },

    /**
     * 显示录音成功提示
     */
    showRecordingTip() {
      this.showSystemAudioTip = true;
      this.systemAudioTipText = 'Microphone recording has started. Please speak into your microphone and maintain a quiet environment for best recording quality.';
    },
    openBrowserRecommendation() {
      window.open('https://www.google.com/chrome/', '_blank');
    },
    /**
     * 检查浏览器兼容性
     * 在开启在线课程模式时检查浏览器是否支持系统音频录制
     */
    checkBrowserCompatibility() {
      // 检测浏览器类型 - 只允许Chrome
      const isChrome = /chrome/i.test(navigator.userAgent) && !/edg/i.test(navigator.userAgent);
      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      const isFirefox = /firefox/i.test(navigator.userAgent);

      if (!isChrome) {
        this.isBrowserIncompatible = true;

        if (isSafari) {
          this.systemAudioTipText = 'Safari browser does not support system audio recording. Please use Chrome for the best experience.';
        } else if (isFirefox) {
          this.systemAudioTipText = 'Firefox browser does not support system audio recording. Please use Chrome for the best experience.';
        } else {
          this.systemAudioTipText = 'Your current browser does not support system audio recording. Please use Chrome for the best experience.';
        }

        this.showSystemAudioTip = true;


        return false;
      } else {
        // Chrome浏览器，重置提示状态
        this.isBrowserIncompatible = false;
        this.showSystemAudioTip = false;
        this.systemAudioTipText = "";
        return true;
      }
    },
    async startSystemAudioRecording() {
      // 重置错误状态
      this.showSystemAudioTip = false;
      this.systemAudioTipText = "";
      this.invalidCaptureType = false;

      console.log("[系统录音] 开始请求系统音频权限");

      // 设置cookie标记录音状态，用于左侧栏点击检测
      this.$cookies.set('ischilddeep', 'islive');

      try {
        // 创建音频上下文
        this.audioContext = new AudioContext({
          latencyHint: 'interactive',
          sampleRate: 44100
        });

        // 请求屏幕共享并包含音频
        this.audioStream = await navigator.mediaDevices.getDisplayMedia({
          video: {
            cursor: 'always'
          },
          audio: true
        });

        // 检查共享类型 - 只允许浏览器标签
        const videoTrack = this.audioStream.getVideoTracks()[0];
        if (videoTrack) {
          const settings = videoTrack.getSettings();
          console.log('[系统录音] 屏幕共享类型:', settings.displaySurface);

          // 检查是否为浏览器标签
          if (settings.displaySurface && settings.displaySurface !== 'browser') {
            // 停止当前音视频流
            this.audioStream.getTracks().forEach(track => track.stop());

            // 设置错误信息
            this.showSystemAudioTip = true;
            const invalidCaptureTip = TipHelper.getSystemAudioTip('INVALID_CAPTURE_TYPE');
            this.systemAudioTipText = invalidCaptureTip.message;
            this.invalidCaptureType = true;

            throw new Error('Only browser tab recording is supported');
          }
        }
        // 检查是否获取到音频轨道
        const audioTracks = this.audioStream.getAudioTracks();
        if (audioTracks.length === 0) {
          this.showSystemAudioTip = true;
          const noAudioTip = TipHelper.getSystemAudioTip('NO_AUDIO_TRACK');
          this.systemAudioTipText = noAudioTip.message;
          throw new Error('No audio track detected');
        }

        console.log('[系统录音] 成功获取系统音频轨道:', audioTracks[0].label);

        // 显示成功提示
        this.showSystemAudioTip = true;
        const successTip = TipHelper.getSystemAudioTip('SUCCESS');
        this.systemAudioTipText = successTip.message;

        // // 5秒后自动关闭成功提示
        // setTimeout(() => {
        //   if (!this.invalidCaptureType && !this.isBrowserIncompatible) {
        //     this.showSystemAudioTip = false;
        //   }
        // }, 5000);

        // 创建音频节点
        this.audioSource = this.audioContext.createMediaStreamSource(this.audioStream);
        this.analyser = this.audioContext.createAnalyser();
        this.analyser.fftSize = 2048;
        this.audioSource.connect(this.analyser);
        this.dataArray = new Uint8Array(this.analyser.frequencyBinCount);

        // 创建 ScriptProcessor 用于处理音频数据
        this.audioProcessor = this.audioContext.createScriptProcessor(this.bufferSize, 2, 2);
        this.audioDestination = this.audioContext.createMediaStreamDestination();

        // 设置音频处理回调
        this.audioProcessor.onaudioprocess = async (e) => {
          if (!this.isRecording) return;

          // 收集音频数据到缓冲区而不是立即生成WAV
          const left = e.inputBuffer.getChannelData(0).slice();
          const right = e.inputBuffer.getChannelData(1).slice();

          // 将音频数据添加到累积缓冲区
          this.systemAudioBuffers.push({
            left: left,
            right: right,
            timestamp: Date.now()
          });

          // 检查是否应该保存数据块（每30秒或缓冲区过大时）
          const currentTime = Date.now();
          if (currentTime - this.lastSaveTime >= this.audioChunkDuration || 
              this.systemAudioBuffers.length >= 1000) {
            await this.saveSystemAudioChunk();
            this.lastSaveTime = currentTime;
          }
        };

        // 连接音频处理管道
        this.audioSource.connect(this.audioProcessor);
        this.audioProcessor.connect(this.audioDestination);
        this.audioProcessor.connect(this.audioContext.destination);

        // 监听用户停止屏幕共享
        if (videoTrack) {
          videoTrack.onended = () => {
            console.log('[系统录音] 用户停止了共享');
            if (this.isRecording) {
              this.stopRecording();
            }
          };
        }

        this.isRecording = true;
        this.isPaused = false;

        // 记录录音开始时间
        if (this.pauseTime != 0) {
          this.startTime += Date.now() - this.pauseTime;
          this.pauseTime = 0;
          console.log(`[系统录音] 恢复录音: 开始时间=${this.startTime}`);
        } else {
          this.startTime = Date.now();
          this.lastSaveTime = Date.now(); // 初始化保存时间
          this.systemAudioBuffers = []; // 重置音频缓冲区
          this.systemAudioSampleRate = this.audioContext.sampleRate;
          console.log(`[系统录音] 新录音: 开始时间=${this.startTime}, 采样率=${this.systemAudioSampleRate}`);
        }
      } catch (error) {
        console.error('[系统录音] 错误:', error);

        // 如果还没有设置提示，则设置一个通用错误提示
        if (!this.showSystemAudioTip) {
          this.showSystemAudioTip = true;
          this.systemAudioTipText = 'Failed to start system audio recording. Please try again.';
        }

        // 确保清理任何已创建的资源
        if (this.audioStream) {
          this.audioStream.getTracks().forEach(track => track.stop());
        }

        if (this.audioContext && this.audioContext.state !== 'closed') {
          await this.audioContext.close().catch(e => console.error('[系统录音] 关闭音频上下文错误:', e));
        }

        // 传递错误以便调用方处理
        throw error;
      }
    },

    // 创建WAV格式缓冲区
    createWavBuffer(leftChannel, rightChannel, sampleRate) {
      const numChannels = 2;
      const bitsPerSample = 16;
      const dataLength = leftChannel.length;

      // 将音频数据转换为16位整数
      const interleavedData = new Int16Array(dataLength * numChannels);
      for (let i = 0; i < dataLength; i++) {
        // 左声道，确保值在 -1 到 1 之间
        interleavedData[i * 2] = Math.max(-1, Math.min(1, leftChannel[i])) * 0x7FFF;
        // 右声道，确保值在 -1 到 1 之间
        interleavedData[i * 2 + 1] = Math.max(-1, Math.min(1, rightChannel[i])) * 0x7FFF;
      }

      // 计算数据大小
      const dataSize = interleavedData.length * (bitsPerSample / 8);
      const buffer = new ArrayBuffer(44 + dataSize);
      const view = new DataView(buffer);

      // 写入WAV头
      this.writeString(view, 0, 'RIFF');
      view.setUint32(4, 36 + dataSize, true);
      this.writeString(view, 8, 'WAVE');

      // fmt子块
      this.writeString(view, 12, 'fmt ');
      view.setUint32(16, 16, true);
      view.setUint16(20, 1, true); // PCM格式
      view.setUint16(22, numChannels, true);
      view.setUint32(24, sampleRate, true);
      view.setUint32(28, sampleRate * numChannels * (bitsPerSample / 8), true);
      view.setUint16(32, numChannels * (bitsPerSample / 8), true);
      view.setUint16(34, bitsPerSample, true);

      // data子块
      this.writeString(view, 36, 'data');
      view.setUint32(40, dataSize, true);

      // 写入音频数据
      const uint8 = new Uint8Array(buffer, 44);
      const dataBytes = new Uint8Array(interleavedData.buffer);
      uint8.set(dataBytes);

      return buffer;
    },

    writeString(view, offset, string) {
      for (let i = 0; i < string.length; i++) {
        view.setUint8(offset + i, string.charCodeAt(i));
      }
    },

    // 保存系统录音数据块
    async saveSystemAudioChunk() {
      if (this.systemAudioBuffers.length === 0) return;

      console.log(`[系统录音] 开始保存数据块: 缓冲区数量=${this.systemAudioBuffers.length}`);

      try {
        // 计算总的音频数据长度
        let totalLength = 0;
        this.systemAudioBuffers.forEach(buffer => {
          totalLength += buffer.left.length;
        });

        console.log(`[系统录音] 总音频长度: ${totalLength}个样本, 约${totalLength / this.systemAudioSampleRate}秒`);

        // 合并所有音频数据
        const mergedLeft = new Float32Array(totalLength);
        const mergedRight = new Float32Array(totalLength);
        let offset = 0;

        for (const buffer of this.systemAudioBuffers) {
          mergedLeft.set(buffer.left, offset);
          mergedRight.set(buffer.right, offset);
          offset += buffer.left.length;
        }

        // 创建WAV buffer
        const wavBuffer = this.createWavBuffer(mergedLeft, mergedRight, this.systemAudioSampleRate);
        const blob = new Blob([wavBuffer], { type: 'audio/wav' });
        
        console.log(`[系统录音] 创建WAV数据块: 大小=${blob.size}字节`);

        // 保存到IndexedDB
        this.chunks.push(blob);
        await this.saveChunk(blob);
        this.chunkCounter++;
        this.lastChunkTime = Date.now();

        // 清空缓冲区
        this.systemAudioBuffers = [];
        
        console.log(`[系统录音] 数据块保存完成: 块ID=${this.chunkCounter}, 大小=${blob.size}字节`);
      } catch (error) {
        console.error(`[系统录音] 保存数据块错误:`, error);
      }
    },
    /**
     * 清理存储的音频数据
     * 确保每次进入录音页面都有一个干净的环境
     */
    async clearStoredAudioData() {
      try {
        console.log("[初始化] 清理旧的录音数据");
        await IndexedDBAudioStorage.clearDB();
        console.log("[初始化] 录音数据清理完成");
        
        // 重置相关状态
        this.audioChunks = [];
        this.chunks = [];
        this.chunkCounter = 0;
        this.systemAudioBuffers = [];
        this.lastSaveTime = 0;
        this.audioUrl = null;
        this.elapsedTime = 0;
        this.currentTime = 0;
        this.isPlaying = false;
        this.isPaused = false;
        this.radiostatus = "notradio";
        
      } catch (error) {
        console.error("[初始化] 清理录音数据失败:", error);
      }
    },

    /**
     * 清理录音相关资源
     * 包括媒体流、录制器、音频处理器等
     */
    cleanupRecordingResources() {
      try {
        // 停止媒体录制器
        if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
          this.mediaRecorder.stop();
        }
        this.mediaRecorder = null;

        // 关闭音频流
        if (this.audioStream) {
          this.audioStream.getTracks().forEach(track => {
            track.stop();
            console.log(`[资源清理] 停止音频轨道: ${track.kind}`);
          });
          this.audioStream = null;
        }

        // 断开音频处理器连接
        if (this.audioProcessor) {
          this.audioProcessor.disconnect();
          this.audioProcessor = null;
        }

        // 断开音频分析器连接
        if (this.analyser) {
          this.analyser.disconnect();
          this.analyser = null;
        }

        // 清理音频目标节点
        if (this.audioDestination) {
          this.audioDestination = null;
        }

        console.log("[资源清理] 录音相关资源清理完成");
      } catch (error) {
        console.error("[资源清理] 清理录音资源时出错:", error);
      }
    },

    /**
     * 重置所有组件状态
     * 确保组件销毁时状态干净
     */
    resetAllStates() {
      // 录音状态
      this.isRecording = false;
      this.isPaused = false;
      this.isPlaying = false;
      this.radiostatus = "notradio";
      
      // 时间相关
      this.startTime = 0;
      this.elapsedTime = 0;
      this.pauseTime = 0;
      this.currentTime = 0;
      this.lastSaveTime = 0;
      this.lastChunkTime = 0;
      
      // 数据相关
      this.audioChunks = [];
      this.chunks = [];
      this.chunkCounter = 0;
      this.systemAudioBuffers = [];
      
      // URL和UI状态
      this.audioUrl = null;
      this.isloading = false;
      this.tipredshow = false;
      this.showSystemAudioTip = false;
      
      // 数组引用
      this.dataArray = null;
      this.playbackDataArray = null;
      
      console.log("[状态重置] 所有组件状态已重置");
    },

    /**
     * 统一的浏览器检测工具
     * 避免重复的正则表达式
     */
    getBrowserInfo() {
      const userAgent = navigator.userAgent;
      return {
        isChrome: /chrome/i.test(userAgent) && !/edg/i.test(userAgent),
        isSafari: /^((?!chrome|android).)*safari/i.test(userAgent),
        isFirefox: /firefox/i.test(userAgent),
        safariVersion: this.getSafariVersion(userAgent)
      };
    },

    /**
     * 获取Safari版本号
     */
    getSafariVersion(userAgent) {
      const match = userAgent.match(/Version\/(\d+)/);
      return match ? parseInt(match[1]) : 0;
    },

    /**
     * 错误边界处理
     * 为异步操作提供统一的错误处理
     */
    async handleAsyncOperation(operation, operationName) {
      try {
        return await operation();
      } catch (error) {
        console.error(`[${operationName}] 操作失败:`, error);
        
        // 根据不同错误类型进行处理
        if (error.name === 'NotAllowedError') {
          this.$message.error('Permission denied, please check your browser settings  ');
        } else if (error.name === 'NotFoundError') {
          this.$message.error('Audio device not found');
        } else if (error.name === 'InvalidStateError') {
          this.$message.error('Audio device state is abnormal, please refresh the page and try again');
        } else {
          this.$message.error(`${operationName} failed, please try again`);
        }
        
        throw error;
      }
    },
  },
  beforeDestroy() {
    console.log("[组件销毁] 开始清理录音组件资源");

    // 清理cookie中的录音状态标记
    this.$cookies.set('ischilddeep', '');

    // 1. 清理定时器
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    
    // 2. 清理动画帧
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
      this.animationFrame = null;
    }
    if (this.playbackAnimationFrame) {
      cancelAnimationFrame(this.playbackAnimationFrame);
      this.playbackAnimationFrame = null;
    }
    
    // 3. 清理录音相关资源
    this.cleanupRecordingResources();
    
    // 4. 清理播放相关资源
    this.cleanupPlaybackResources();
    
    // 5. 清理音频上下文
    if (this.audioContext && this.audioContext.state !== "closed") {
      this.audioContext.close().catch(error => 
        console.error("[组件销毁] 关闭录音音频上下文失败:", error)
      );
    }
    
    if (this.playaudioContext && this.playaudioContext.state !== "closed") {
      this.playaudioContext.close().catch(error => 
        console.error("[组件销毁] 关闭播放音频上下文失败:", error)
      );
    }
    
    // 6. 清理 IndexedDB（异步，不阻塞销毁过程）
    IndexedDBAudioStorage.clearDB().catch(error => 
      console.error("[组件销毁] 清理IndexedDB失败:", error)
    );
    
    // 7. 重置所有状态
    this.resetAllStates();
    
    console.log("[组件销毁] 录音组件资源清理完成");
  },
  watch: {
    // 监听录音模式变化
    isSystemAudio(newVal) {
      if (newVal) {
        // 开启在线课程模式时检查浏览器兼容性
        this.checkBrowserCompatibility();
      } else {
        // 当从系统录音切换到麦克风录音时，关闭提示
        this.showSystemAudioTip = false;
        this.isBrowserIncompatible = false;
        this.systemAudioTipText = "";
        console.log('[录音] 切换到麦克风录音模式，关闭系统录音提示');
      }
    }
  },
};
</script>

<style lang="less" scoped>
.record-lecture {
  color: #E5E7EB;
  padding: 40px;
  text-align: center;
  background-color: #111827;
  min-height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  align-items: center;

  .qiehuan {
    margin-top: 2vw;
  }

  .backhome {
    cursor: pointer;
    width: 11vw;
    height: 15vh;
    position: absolute;
    left: 1vw;
    top: 1vw;
  }
}

.tipbox {
  font-size: 0.9vw;
  text-align: center;
  margin: 3vw auto 0;
  color: #9CA3AF;
  line-height: 1.6;
  max-width: 40vw;
}

h1 {
  font-size: 2.2vw;
  margin-bottom: 1.5vw;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.8vw;
  color: #F3F4F6;

  img {
    width: 2vw;
    height: 2vw;
    filter: brightness(0.9);
  }
}

p {
  font-size: 1.1vw;
  color: #D1D5DB;
  margin: 0.5vw 0;
}

.notradio {
  margin-top: 15vh;

  .record-button1 {
    cursor: pointer;
    background-color: #EF4444;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
    margin: 0 auto;
  }

  .record-button1 i {
    font-size: 30px;
    color: #FFFFFF;
  }

  .record-button1:hover {
    background-color: #DC2626;
    transform: scale(1.1);
    box-shadow: 0 6px 16px rgba(239, 68, 68, 0.4);
  }
}

.waveform {
  width: 70%;
  height: 100px;
  margin: 2vw auto;
  overflow: hidden;
  position: relative;
  background-color: #1F2937;
  border-radius: 12px;
  padding: 1vw;

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100px;
    height: 100%;
    z-index: 1;
  }

  &::before {
    left: 0;
    background: linear-gradient(to right, #111827, transparent);
  }

  &::after {
    right: 0;
    background: linear-gradient(to left, #111827, transparent);
  }
}

.clear-button {
  padding: 0.8vw 1.5vw;
  font-size: 1vw;
  border-radius: 8px;
  font-weight: 500;
  color: #EF4444;
  background-color: #1F2937;
  margin-left: 1.5vw;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #374151;

  &:hover {
    color: #fff;
    background-color: #EF4444;
    border-color: #EF4444;
  }
}

.controls {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 1.5vw;
  gap: 1.5vw;

  .record-button {
    background: none;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.3s ease;

    i {
      font-size: 3.5vw;
      color: #EF4444;
    }

    .record-button-microphone {
      color: #E5E7EB;
    }

    &:hover {
      transform: scale(1.05);

      i {
        opacity: 0.8;
      }
    }
  }

  .stop-button {
    background-color: #EF4444;
    padding: 1vw;
    border-radius: 50%;
    border: 2px solid #374151;
    cursor: pointer;
    transition: all 0.3s ease;

    i {
      width: 1.2vw;
      height: 1.2vw;
      background-color: #fff;
      display: inline-block;
      border-radius: 4px;
    }

    &:hover {
      background-color: #DC2626;
      transform: scale(1.05);
    }
  }
}

.overaudiobox {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 2vw;
  width: 100%;
  max-width: 40vw;
  margin: 0 auto;

  .generate-notes-button {
    font-size: 1.1vw;
    border-radius: 8px;
    border: none;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    font-weight: 500;
    color: #fff;
    background-color: #059669;
    cursor: pointer;
    position: relative;
    justify-content: center;
    width: 100%;
    height: 3vw;
    margin-top: 1.5vw;
    transition: all 0.3s ease;

    i {
      font-size: 1.1vw;
      position: absolute;
      right: 1vw;
    }

    &:hover {
      background-color: #047857;
      transform: translateY(-2px);
    }
  }

  .download-button {
    width: 16vw;
    margin: 1vw 0 0;
    font-size: 1vw;
    padding: 0.8vw 1.2vw !important;
  }
}

@keyframes shake {

  0%,
  100% {
    transform: translateX(0);
  }

  25% {
    transform: translateX(-10px);
  }

  50% {
    transform: translateX(10px);
  }

  75% {
    transform: translateX(-10px);
  }
}

.tipred {
  display: inline-block;
  color: #EF4444;
  margin: 0.8vw 0;
  font-size: 1vw;

  &.shake {
    animation: shake 0.3s;
  }
}

.modal-content {
  background-color: transparent;
  border-radius: 12px;
  padding: 2vw;
  width: 100%;
  position: relative;

  // border: 1px solid #374151;
  .recordtitle {
    margin-bottom: 1.5vw;

    label {
      display: block;
      text-align: left;
      margin-bottom: 0.5vw;
      color: #2c3e50;
      font-size: 1vw;
    }
  }

  input {
    width: calc(100% - 24px);
    padding: 12px;
    border-radius: 8px;
    border: 1px solid #374151;
    // background-color: #111827;
    color: #2c3e50;
    font-size: 1vw;
    transition: all 0.3s ease;

    &:focus {
      outline: none;
      border-color: #4B5563;
      box-shadow: 0 0 0 2px rgba(75, 85, 99, 0.2);
    }

    &::placeholder {
      color: #9CA3AF;
    }
  }
}

.timer {
  font-size: 1.2vw;
  color: #E5E7EB;
  margin: 1vw 0;
  font-weight: 500;
}



.record-mode-header {
  margin-top: 30px;
  width: 300px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.record-mode-title {
  font-size: 16px;
  font-weight: 600;
  color: #E5E7EB;
}

.record-mode-toggle {
  display: flex;
  align-items: center;
}

.toggle-labels {
  display: flex;
  align-items: center;
  margin-left: 10px;

  .tip-text {
    i {
      font-size: 16px;
      margin-right: 5px;
      cursor: pointer;
    }

    span {
      font-size: 16px;
      color: #9CA3AF;
    }
  }
}

.toggle-labels span {
  font-size: 16px;
  color: #9CA3AF;
  margin-right: 5px;
  transition: all 0.3s ease;
}

.toggle-labels span.active {
  color: #FFFFFF;
  font-weight: 600;
}

/* 开关样式 */
.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #374151;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 0px;
  bottom: 0px;
  background-color: #D1D5DB;
  transition: .4s;
}

input:checked+.slider {
  background-color: #EF4444;
}

input:focus+.slider {
  box-shadow: 0 0 6px rgba(239, 68, 68, 0.5);
}

input:checked+.slider:before {
  transform: translateX(20px);
}

.slider.round {
  border-radius: 28px;
}

.slider.round:before {
  border-radius: 50%;
}

.tip-container {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

.system-audio-tip {
  bottom: 30px;
  width: 90%;
  max-width: 480px;
  background-color: #1F2937;
  border-radius: 12px;
  padding: 16px 20px;
  color: #E5E7EB;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  z-index: 1000;
  display: flex;
  align-items: flex-start;

  .tip-icon {
    font-size: 24px;
    color: #ff7b7b;
    margin-right: 15px;
    margin-top: 3px;
  }

  .tip-content {
    flex: 1;
    text-align: left;

    h3 {
      font-size: 16px;
      margin: 0 0 8px 0;
      color: #fff;
      font-weight: 600;
    }

    p {
      font-size: 14px;
      color: #D1D5DB;
      margin: 0;
      line-height: 1.5;
    }
  }

  .tip-close {
    cursor: pointer;
    font-size: 18px;
    color: #9CA3AF;
    margin-left: 10px;
    transition: color 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;

    &:hover {
      color: #fff;
    }
  }

  &.error {
    background-color: rgba(239, 68, 68, 0.1);
    border-color: rgba(239, 68, 68, 0.3);

    .tip-icon {
      color: #EF4444;
    }
  }

  &.warning {
    background-color: rgba(234, 179, 8, 0.1);
    border-color: rgba(234, 179, 8, 0.3);

    .tip-icon {
      color: #EAB308;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(20px);
}

.browser-recommendation {
  margin-top: 10px;
  font-size: 14px;
  color: #D1D5DB;

  .browser-icons {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-top: 5px;

    .browser-icon {
      display: flex;
      align-items: center;
      gap: 5px;
      cursor: pointer;
      img {
        width: 24px;
        height: 24px;
      }

      span {
        font-size: 14px;
        color: #D1D5DB;
      }
    }
  }
}

/* 自定义tooltip样式 */
::v-deep .audio-tip-tooltip {
  max-width: 300px;

  background: #1F2937;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.5;
  color: #E5E7EB;

  &[x-placement^="right"] .popper__arrow {
    border-right-color: #1F2937;

    &::after {
      border-right-color: #1F2937;
    }
  }
}

.tip-text {
  position: relative;

  i {
    font-size: 16px;
    margin-right: 5px;
    cursor: pointer;
    color: #9CA3AF;
    transition: all 0.3s ease;

    &:hover {
      color: #E5E7EB;
    }
  }

  .custom-tooltip-diy {
    position: relative;
    display: inline-block;

    .tooltip-content {
      visibility: hidden;
      opacity: 0;
      position: absolute;
      left: calc(100% + 10px);
      top: 50%;
      transform: translateY(-50%);
      width: max-content;
      max-width: 300px;
      background: #1F2937;
      border: 1px solid rgba(255, 255, 255, 0.1);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
      border-radius: 8px;
      padding: 10px 12px;
      font-size: 14px;
      line-height: 1.5;
      color: #E5E7EB;
      z-index: 1000;
      transition: all 0.3s ease;
      pointer-events: none;

      &::before {
        content: '';
        position: absolute;
        right: 100%;
        top: 50%;
        transform: translateY(-50%);
        border: 6px solid transparent;
        border-right-color: #1F2937;
      }
    }

    &:hover .tooltip-content {
      visibility: visible;
      opacity: 1;
    }
  }
}
</style>
